import { apiClient } from '@/lib/api/client';
import { UserBackendResponse } from '@/types/user.types';
import { USE_MOCK_AUTH, mockGetCurrentUser } from '@/mocks/authMock';

export const userService = {
  /**
   * Get current authenticated user's profile
   * GET /users/me
   */
  getCurrentUser: async (token?: string): Promise<UserBackendResponse> => {
    // Use mock auth if enabled
    if (USE_MOCK_AUTH) {
      const mockUser = await mockGetCurrentUser();
      // Transform mock user to backend response format if needed, or just return it
      // The mock user matches the User interface, but UserBackendResponse might be different?
      // Let's check types. Assuming they are compatible for now or casting.
      return mockUser as unknown as UserBackendResponse;
    }

    // Use the provided token for immediate auth, otherwise rely on the interceptor
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    const { data } = await apiClient.get<UserBackendResponse>('/users/me', { headers });
    return data;
  },

  /**
   * Update current user's profile
   * PATCH /users/me
   */
  updateProfile: async (updates: Partial<UserBackendResponse>): Promise<UserBackendResponse> => {
    const { data } = await apiClient.patch<UserBackendResponse>('/users/me', updates);
    return data;
  },
};
